// ACF Field Group Names //
export const heroBlock = "ModulesModuleHeroBlockLayout";
export const textImageBlock = "ModulesModuleTextAndImageBlockLayout";
export const postsDisplayBlock = "ModulesModulePostsDisplayBlockLayout";
export const contentBlock = "ModulesModuleContentBlockLayout";
export const galleryBlock = "ModulesModuleGalleryBlockLayout";
export const gravityFormBlock = "ModulesModuleGravityFormBlockLayout";
export const accordionBlock = "ModulesModuleAccordionBlockLayout";
